<script lang="ts" setup>
type Props = {
  href: string;
  target?: string;
  rel?: string;
  class?: string;
  style?: string;
  title?: string;
};

const props = defineProps<Props>();
</script>
<template>
  <a
    v-bind="props"
    :class="[
      'cursor-pointer',
      'text-primary-600 hover:text-primary-700 dark:text-primary-300 hover:dark:text-primary-400 hover:underline',
      props.class,
    ]"
  >
    <slot />
  </a>
</template>
